<script>
  import LocationPin from "../../icons/location.svg";
</script>

<div class="c-event-details__detail">
  <span class="c-event-details__icon">
    <LocationPin width="14" height="14" />
  </span>
  <span>Online</span>
</div>

<style>
  @keyframes animateFade {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .c-event-details__detail {
    display: flex;
    margin-top: 12px;
  }

  .c-event-details__icon {
    margin-right: 12px;
    display: flex;
    align-items: center;
  }

  .c-event-details__icon :global(path) {
    fill: var(--pink-500);
  }

  .c-event-details__icon :global(path.inner) {
    animation: animateFade 2s linear 0s infinite;
  }
</style>
